module.exports = __webpack_public_path__ + "img/open.cadfe73e.svg";